// import { createMuiTheme } from '@material-ui/core/styles' will fail tests for some reason
// eslint-disable-next-line no-restricted-imports
import { createTheme } from '@mui/material/styles';
import { rgba2rgb } from '../themeFunctions';
import defaultColors from './colors';
import overrides from '../overrides';
import { typography, themeProps as props } from '../common';

const theme = createTheme();

// We need a defaultColors, because in test mode the colors would be undefined.
// Colors.* crashing the test process

export default (colors = defaultColors) => ({
    themeName: 'Dark Theme',
    id: 'dark',
    palette: {
        common: {
            white: colors.accentLight[1],
            black: colors.productBase[1],
            tooltipText: colors.const.tooltipText, // not used in the project
            loginColor: colors.loginPage.color,
            loginBackground: colors.loginPage.background,
            icon: colors.icon.main,
            grey: '#424242', // added after MUIV5 upgrade to avoid test error
        },
        primary: {
            main: colors.accentMedium[1],
            light: colors.accentBright[1],
            dark: colors.accentBright[0.5], // not used in the project
            contrastText: colors.contrastText, // not used in the project
        },
        secondary: {
            main: colors.sysGreen[1],
        },
        background: {
            paper: rgba2rgb(colors.productBase[1], colors.accentLight[1], 0.08),
            dateThumbnail: colors.liveGreen[1],
            default: colors.productBase[1],
            root: colors.accentDark[1],
            input: colors.accentDark[0.4],
            downloadProgress: colors.downloadProgress,
            downloadReady: colors.downloadReady,
            downloadWaiting: colors.downloadWaiting,
            downloadFailed: colors.downloadFailed,
        },
        text: {
            primary: colors.accentLight[1],
            secondary: colors.accentBright[1],
            tertiary: colors.accentLight[0.6],
            disabled: colors.neutral800,
            hover: colors.accentLight[0.9], // not used in the project
        },
        icon: {
            light: colors.neutral800,
            active: colors.accentBright[1],
            hover: colors.accentDark[0.6],
            dark: colors.neutral200, // not used in the project
        },
        border: {
            light: `1px solid ${colors.borderLight}`,
            dark: colors.neutral700,
            hover: colors.neutral700, // not used in the project
            main: colors.neutral000,
            accent: colors.accentMedium[1],
        },
        action: {
            focus: colors.focused[1],
            hover: colors.accentLight[0.08],
        },
        warning: {
            main: colors.sysYellow[1],
        },
        error: {
            main: colors.sysRed[1],
        },
        info: {
            main: colors.sysBlue[1],
        },
        success: {
            main: colors.sysGreen[1],
        },
        outlined: {
            text: colors.accentBright[1],
            background: colors.accentDark[0.6],
        },
        leftMenu: {
            background: colors.accentDark[1],
        },
        buttonBackground: {
            primary: colors.neutral600, // not used in the project
            search: colors.neutral600, // not used in the project
            hover: colors.neutral700, // not used in the project
        },
        buttonSecondary: {
            text: colors.neutral100,
            background: colors.neutral700,
        },
        opacity: {
            sidebar: 0.4, // not used in the project
        },
        type: 'dark', // not used in the project, but maybe necessary for MUI?
    },
    custom: colors,
    layout: {
        line: {
            height: '3px',
        },
    },
    props,
    typography,
    ...overrides(theme, colors),
});
